<template>
  <div id="forgot">
    <div class="main">
      <h2>{{$t('cmsg.forgotPwd')}}</h2>
      <div class="login_panel">
      <el-row :gutter="15">
        <el-col :span="16">
  <el-tabs v-model="activeTab" >
    <el-tab-pane :label="$t('cmsg.byEmail')" name="emailForgot"><emailForgot /></el-tab-pane>
    <el-tab-pane :label="$t('cmsg.byMobile')" name="mobileForgot"><phoneForgot/></el-tab-pane>
  </el-tabs>
      </el-col>
        <el-col :span="8"><rightSide/></el-col>
      </el-row>
      </div>
    </div>
    <bottomWrapper/>
    </div>
</template>
<script>
import bottomWrapper from "@/views/component/bottom.vue";
import emailForgot from "./component/forgot/email.vue"
import phoneForgot from "./component/forgot/phone.vue"
import rightSide from "./component/rightSide.vue";
export default {
  components: {
    bottomWrapper,
    emailForgot,
    phoneForgot,
    rightSide
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.forgotPwd"),
      meta: [
        { vmid: "description", name: "description", content: "Shining3D Login" }
      ]
    };
  },
  data() {
    return {
      activeTab: "emailForgot"
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss">
#forgot {
  .main {
    background-color: #F7F9FB;
    padding: 15px 0px;
    h2 {
      // min-width: 1200px;
      width: 65vw;
    @media only screen and (max-width: 1020px) {
      width: 95vw;
    }
      text-align: left;
      margin: 0 auto;
      border-bottom: 5px solid #4b91d1;
      margin-bottom: 15px;
      padding-bottom: 5px;
    }
    .login_panel {
    // min-width: 1200px;
    width: 65vw;
    @media only screen and (max-width: 1020px) {
      width: 95vw;
    }
    margin: 0 auto;
    }
  }
}
</style>
